import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import LogisticsExpensesMobile from "../mobile/logistics/LogisticsExpensesMobile";
import LogisticsExpenses from "./pages/LogisticsExpenses";

export default function ResponsiveLogisticsExpenses(props) {
  return useIsMobile() ? <LogisticsExpensesMobile {...props} /> : <LogisticsExpenses {...props} />;
}
